export const typeColors = {
  turnips: 'bg-yellow-400 text-black',
  crafting: 'bg-teal-400 text-black',
  treasure: 'bg-sky-400 text-black',
  catalog: 'bg-red-400 text-black',
  event: 'bg-purple-400 text-black',
} as const

export const typeBorders = {
  turnips: 'border-yellow-400',
  crafting: 'border-teal-400',
  treasure: 'border-sky-400',
  catalog: 'border-red-400',
  event: 'border-purple-400',
} as const

export const backgroundMap: Record<string, string> = {
  '': '',
  'bones-dark': "bg-[url('/images/backgrounds/bones-dark.png')]",
  'bones-light': "bg-[url('/images/backgrounds/bones-light.png')]",
  'butterflies-dark': "bg-[url('/images/backgrounds/butterflies-dark.png')]",
  'butterflies-light': "bg-[url('/images/backgrounds/butterflies-light.png')]",
  'coins-dark': "bg-[url('/images/backgrounds/coins-dark.png')]",
  'coins-light': "bg-[url('/images/backgrounds/coins-light.png')]",
  'fish-dark': "bg-[url('/images/backgrounds/fish-dark.png')]",
  'fish-light': "bg-[url('/images/backgrounds/fish-light.png')]",
  'fruits-dark': "bg-[url('/images/backgrounds/fruits-dark.png')]",
  'fruits-light': "bg-[url('/images/backgrounds/fruits-light.png')]",
  'leafs-dark': "bg-[url('/images/backgrounds/leafs-dark.png')]",
  'leafs-light': "bg-[url('/images/backgrounds/leafs-light.png')]",
  'nookazon-exchange-dark': "bg-[url('/images/backgrounds/nookazon-exchange-dark.png')]",
  'nookazon-exchange-light': "bg-[url('/images/backgrounds/nookazon-exchange-light.png')]",
  'nups-dark': "bg-[url('/images/backgrounds/nups-dark.png')]",
  'nups-light': "bg-[url('/images/backgrounds/nups-light.png')]",
  'spiders-dark': "bg-[url('/images/backgrounds/spiders-dark.png')]",
  'spiders-light': "bg-[url('/images/backgrounds/spiders-light.png')]",
}

export const clampTurnipPrice = (price: number) => {
  if (price >= 999) return '999+'

  return price
}
